const EditorRenderModes = {
  EDIT: 'EDIT',
  PREVIEW: 'PREVIEW',
  ADD: 'ADD'
};

export default EditorRenderModes;
